import Picker from '@emoji-mart/react';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import Popover from '@mui/material/Popover';
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import React, { useState } from 'react';
import Button from '../Button/Button';

const EmojiModal = ({ onPick, show }) => {
  const onClick = (emo) => {
    onPick(emo.native);
  };

  if (!show) return null;
  return (
    <StyledEmojiPopup>
      <Picker
        onEmojiSelect={onClick}
        showPreview={false}
        showSkinTones
        title=""
      />
    </StyledEmojiPopup>
  );
};

const EmojiPicker = ({ onSelect }) => {
  const popupState = usePopupState({
    popupId: 'emoji',
    variant: 'popover',
  });

  const onEmojiSelect = (val) => {
    onSelect(val.native);
    popupState.close();
  };

  return (
    <>
      <Button
        rounded
        variant="text"
        size="small"
        color="secondary"
        startIcon={<EmojiEmotionsOutlinedIcon />}
        {...bindTrigger(popupState)}
      >
        Emojis
      </Button>
      <Popover {...bindPopover(popupState)}>
        <Picker
          onEmojiSelect={onEmojiSelect}
          showPreview={false}
          showSkinTones
          title=""
        />
      </Popover>
    </>
  );
};

export default EmojiPicker;
